import { _ as h } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.parse-int-d7709701.js";
import { c } from "./index-8b07dec9.js";
import p, { css as d } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as y } from "./getMetrics-953aa4f8.js";
import { jsx as m } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./string-trim-14e37ad3.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var M = ["links", "itemGap", "alignment", "color", "className"], $ = /* @__PURE__ */ p.div.withConfig({
  displayName: "mediaDisclosureButton__DisclosureButtonsContainer",
  componentId: "oq93p3-0"
})(["&.MediaDisclosureButton{", ";}"], function(i) {
  var t = i.theme.components.mediaDisclosureButton, s = i.$styles;
  return d(t.DisclosureButtonsContainer, s);
}), _ = /* @__PURE__ */ p.button.withConfig({
  displayName: "mediaDisclosureButton__DisclosureButton",
  componentId: "oq93p3-1"
})(["&.DisclosureButton{", ";}"], function(i) {
  var t = i.theme.components.mediaDisclosureButton;
  return d(t.DisclosureButton);
}), ao = function(t) {
  var s = t.links, n = s === void 0 ? [] : s, e = t.itemGap, D = e === void 0 ? "8px" : e, l = t.alignment, B = l === void 0 ? "bottom-right" : l, u = t.color, a = u === void 0 ? "onColor" : u, k = t.className, v = h(t, M), f = y({
    label: "MediaDisclosureButton"
  });
  if (!n.length)
    return null;
  var g = function(o, C) {
    return /* @__PURE__ */ m(_, Object.assign({
      id: o.id,
      type: "button",
      className: c(["DisclosureButton", "DisclosureButton--" + a]),
      "data-disclosure-number": o.disclosureNumber || isNaN(parseInt("" + o.linkTitle)) ? C + 1 : parseInt("" + o.linkTitle),
      onClick: function(r) {
        return o.onClick == null ? void 0 : o.onClick(r, o.id);
      },
      onKeyDown: function(r) {
        var b = r.code === "Enter" || r.code === "Space";
        b && (o.onClick == null || o.onClick(r, o.id));
      }
    }, o, {
      children: o.linkTitle
    }), o.linkTitle);
  };
  return /* @__PURE__ */ m($, Object.assign({
    $styles: {
      gap: D
    },
    className: c(["MediaDisclosureButton", "MediaDisclosureButton--" + a, "MediaDisclosureButton--" + B, k])
  }, f, v, {
    children: n.map(g)
  }));
};
export {
  ao as MediaDisclosureButton
};
